import React, { useEffect, useState } from "react";
import LandingPageFooter from "../../organs/Landing/LandingPageFooter";
import LandingPageLinks from "../../organs/Landing/LandingPageLinks";
import LandingPageMission from "../../organs/Landing/LandingPageMission";
import AnimatedText from '../../organs/SplashScreen';
import HowWeWork from "../../organs/Landing/HowWeWork";
import logo from '../../assets/images/logo.webp';
import LogoTopHeader from "../../organs/Landing/LogoTopHeader";
import Language from "../../organs/Landing/Language";
import { useTranslation } from "react-i18next";

const LandingPage = () => {
    const { t } = useTranslation();

    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0.5,
        },
      );
      const section = document.getElementById("hero-section");
      if (section) {
        observer.observe(section);
      }
      return () => {
        if (section) {
          observer.unobserve(section);
        }
      };
    }, []);

    return (
        <>
        <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          main {
            width: 100%;
          }
          #hero-section {
            width: 100%;
            height: 100vh;
            
          }

          .heroWrapper {
          height: 100%;
          width: 100%;
          position: relative;
          overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 10rem;
          }
          .hero {
            background-color: white;
            opacity: 0;
            transition: opacity 0.5s ease;
          }
          .hero.visible {
            opacity: 1;
          }
          .hero h1 {
            font-size: 2.25rem;
            font-weight: 300;
            letter-spacing: 0.05em;
            display: flex;
            flex-direction: column;
            align-items: center;
            
          }
            .hero-subtitle {
            padding: 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            font-size: small;
            }

            @media screen and (max-width:780px){
            .word {
                   padding-left: 2rem;
    padding-right: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
              }
            }
          @media screen and (min-width: 1200px) {
            .hero h1 {
              font-size: 3.75rem;
              flex-direction: column;
            }
              .hero-subtitle {
              flex-direction: row;
              font-size: medium;
              }
              
          }
          .word {
            display: flex;
            margin: 0 0.5rem;
            opacity: 0;
            transform: translateY(20px);
           
          }
            .subText {
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
            }
            .wordPart {
              display: flex;
              flex-direction: row;
            }
              @media screen and (max-width: 780px){
              .wordPart {
              flex-direction: column;
              text-align: start;
              justify-content: center;
              align-items: center;
              }
              }
              .hero.visible .h1 {
              text-align: center;
              }
          .hero.visible .word:nth-child(1) {
            animation: fadeInUp 0.5s ease forwards;
          }
          .hero.visible .word:nth-child(2) {
            animation: fadeInUp 0.5s ease forwards 0.1s;
          }
          .hero.visible .word:nth-child(3) {
            animation: fadeInUp 0.5s ease forwards 0.2s;
          }
            .hero.visible .word:nth-child(4) {
            animation: fadeInUp 0.5s ease forwards 0.3s;
          }
          .hero:not(.visible) .word:nth-child(1) {
            animation: fadeOutDown 0.5s ease forwards 0.3s;
          }
          .hero:not(.visible) .word:nth-child(2) {
            animation: fadeOutDown 0.5s ease forwards 0.2s;
          }
          .hero:not(.visible) .word:nth-child(3) {
            animation: fadeOutDown 0.5s ease forwards 0.1s;
          }
             .hero:not(.visible) .word:nth-child(4) {
            animation: fadeOutDown 0.5s ease forwards;
          }
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes fadeOutDown {
            from {
              opacity: 1;
              transform: translateY(0);
            }
            to {
              opacity: 0;
              transform: translateY(20px);
            }
          }
         
            *{
            cursor: default !important;
            }
            

             .gradient-circle {
            position: absolute;
            width: 400px;
            height: 400px;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.7;
            mix-blend-mode: multiply;
          }
          .circle-1 {
            top: 10%;
            left: 15%;
            background: rgb(140, 180, 218);
            animation: flow 4s ease-in-out infinite;
          }
          .circle-2 {
            top: 20%;
            right: 15%;
            background: rgb(198, 246, 213);
            animation: flow 3s ease-in-out infinite;
            animation-delay: -2s;
          }
          .circle-3 {
            bottom: 10%;
            left: 30%;
            background: rgb(164, 214, 182);
            animation: flow 3s ease-in-out infinite;
            animation-delay: -4s;
          }
          .circle-4 {
            top: 5%;
            left: 5%;
            width: 300px;
            height: 300px;
            background: rgb(233, 220, 167);
            animation: flow3 6s ease-in-out infinite;
            animation-delay: -3s;
          }
          .circle-5 {
            bottom: 5%;
            right: 5%;
            width: 300px;
            height: 300px;
            background: rgb(253, 186, 116);
            animation: flow 4s ease-in-out infinite;
            animation-delay: -6s;
          }
            .circle-6 {
            bottom: 45%;
            right: 35%;
            width: 300px;
            height: 300px;
            background: rgb(190, 180, 251);
            animation: flow2 9s ease-in-out infinite;
            animation-delay: -6s;
          }
            @keyframes flow {
            0% {
              transform: translate(0px, 0px) scale(1);
            }
            25% {
              transform: translate(100px, 50px) scale(1.1);
            }
            50% {
              transform: translate(50px, 100px) scale(1);
            }
            75% {
              transform: translate(-50px, 30px) scale(0.9);
            }
            100% {
              transform: translate(0px, 0px) scale(1);
            }
          }

           @keyframes flow2 {
            0% {
              transform: translate(0px, 0px) scale(1);
            }
            25% {
              transform: translate(200px, 70px) scale(1.3);
            }
            50% {
              transform: translate(300px, 100px) scale(1);
            }
            75% {
              transform: translate(100px, 30px) scale(0.8);
            }
            100% {
              transform: translate(0px, 0px) scale(1);
            }
          }

          @keyframes flow3 {
            0% {
              transform: translate(0px, 0px) scale(1);
            }
            25% {
              transform: translate(20px, 200px) scale(2.1);
            }
            50% {
              transform: translate(-100px, 170px) scale(2);
            }
            75% {
              transform: translate(40px, 50px) scale(0.6);
            }
            100% {
              transform: translate(0px, 0px) scale(1);
            }
          }
          
        `}
      </style>
   <main>
    {/* <AnimatedText/> */}
        <section
          id="hero-section"
          className={`hero ${isVisible ? "visible" : ""}`}
        >
            <div className="heroWrapper">
            <div className="gradient-circle circle-1"></div>
            <div className="gradient-circle circle-2"></div>
            <div className="gradient-circle circle-3"></div>
            <div className="gradient-circle circle-4"></div>
            <div className="gradient-circle circle-5"></div>
            <div className="gradient-circle circle-6"></div>
                <h1>
                 <span className="word">{t('designSmarter')} </span>
                 <span className="word">{t('buildBetter')}</span>
                  <span className="word">{t('coordinateEverything')}</span>
                </h1> 
            <p className="hero-subtitle"><strong>archiCODE. </strong> <span className="subText">{t('archicodeAbout')}</span></p>
            </div>
         
        </section>
        <section className="third-section">
            <div>
            <div>
              <LandingPageLinks/>
            </div>
            </div>
        </section>
       <section className="fourth-section">
        <div>
            <HowWeWork/>
        </div>
        
       </section>
        <LandingPageFooter/>
      </main>
        <Language/>
        </>
    )
}

export default LandingPage;
